module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/tz-20af2614818e325d953d7ed0c602923c.svg";